import { MessageOutlined } from "@ant-design/icons";
import clsx from "clsx";
import { useCallback, type MouseEvent } from "react";
import "./SearchChatResultItem.scss";

export type SearchChatResultItemProps = {
  id: string;
  title: string;
  subtitle?: string;
  active?: boolean;
  onSelect?: (id: string) => void;
};

const SearchChatResultItem = ({
  id,
  title,
  subtitle,
  active = false,
  onSelect,
}: SearchChatResultItemProps) => {
  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      const itemId = event.currentTarget.dataset.id;
      if (itemId) {
        onSelect?.(itemId);
      }
    },
    [onSelect],
  );

  return (
    <button
      type="button"
      className={clsx(
        "search-chat-result-item",
        active && "search-chat-result-item--active",
      )}
      data-id={id}
      onClick={handleClick}
      aria-current={active ? "true" : undefined}
    >
      <span className="search-chat-result-item__icon" aria-hidden>
        <MessageOutlined />
      </span>
      <span className="search-chat-result-item__body">
        <span className="search-chat-result-item__title">{title}</span>
        {subtitle ? (
          <span className="search-chat-result-item__subtitle">{subtitle}</span>
        ) : null}
      </span>
    </button>
  );
};

export default SearchChatResultItem;
